<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                <span *ngIf="!UserId">Adding User</span>
                <span *ngIf="UserId">Update User</span>
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="userForm" (submit)="createUser()">

                <div class="card-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-6 col-lg-6 right-border">
                                <div class="form-group">
                                    <label class="form-label">Name *</label>
                                    <input  type="text" formControlName="name" class="form-control" />
                                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        <div *ngIf="f.name.errors.required">Name is required</div>
                                    </div>
                                </div>
                                
                                <div class="form-group">
                                    <label class="form-label">Email</label>
                                    <input  type="text" formControlName="email" class="form-control" />
                                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                        <div *ngIf="!f.email.valid && f.email.value">Email format is Invalid</div>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label class="form-label">Mobile *</label>
                                    <input type="text" formControlName="mobile" class="form-control" />
                                    <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                                        <div *ngIf="f.mobile.errors.required">Mobile is required</div>
                                        <div *ngIf="!f.mobile.valid && f.mobile.value">Invalid Mobile number format</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="form-label">Status *</label>
                                    <mat-select  placeholder="Status" formControlName="status">
                                        <mat-option [value]="1">Active</mat-option>
                                        <mat-option [value]="0">In-Active</mat-option>

                                    </mat-select>
                                    <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                        <div *ngIf="f.status.errors.required">Status is required</div>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label class="form-label">Affiliate Type</label>
                                    <mat-select  placeholder="Affiliate Type" formControlName="affiliate_type">
                                        <mat-option [value]="1">Ambulance</mat-option>
                                        <mat-option [value]="2">Optical Clinics</mat-option>
                                        <mat-option [value]="3">Doctors</mat-option>
                                        <mat-option [value]="4">Insurance Agent</mat-option>
                                        <mat-option [value]="5">Compititors</mat-option>
                                        <mat-option [value]="6">Others</mat-option>
                                    </mat-select>
                                    
                                </div>
                                <!-- <div class="form-group">
                                    <label class="form-label">Password <span *ngIf="!UserId">*</span></label>
                                    <input autocomplete="new-password"  [type]="passwordhide ? 'password' : 'text'" formControlName="password" class="form-control input-password" />
                                    <mat-icon class="passwordicon" (click)="showPassword()">{{passwordhide ? 'visibility_off' : 'visibility'}}</mat-icon>
                                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                        <div *ngIf="f.password.errors.required">Password is required</div>
                                        <div *ngIf="!f.password.valid && f.password.value">Your password must be minimum 8 characters.</div>

                                    </div>
                                </div> -->

                            </div>

                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label class="form-label">Margin Percentage</label>
                                    <input  type="number" formControlName="margin_percentage" class="form-control" />
                                </div>

                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i>
                         <span *ngIf="!UserId">Create User</span>
                        <span *ngIf="UserId">Update User</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
